<div class="subheader">
  <h1 class="subheader-title">
    <i class='subheader-icon fal fa-globe'></i> {{header}}
  </h1>
</div>

<app-error-message [errorMessage]="errorMessage"></app-error-message>

<div class="card p-g d-block">

  <div class="col-12 col-md-12">
    <app-date-picker [dateRange]="dateRangeToShow" (navOut)="onDateRangeUpdated($event)"></app-date-picker>
  </div>

  <div class="row">&nbsp;</div>

  <div id="billHeader" class="panel" *ngIf="featureReport && !loadingPrimary">
    <div class="panel-hdr">
      <h2>Meter Details</h2>
    </div>
    <app-bill *ngIf="provisionalBill"
              [bill]="provisionalBill"
              [showHeader]="true"
              [showBill]="false">
    </app-bill>
  </div>

  <div class="row" *ngIf="!loadingPrimary">
    <div class="col-12" [ngClass]="(saving || loadingSecondary) && !featureReport ? 'col-md-9' : ' col-md-12'" *ngIf="graph">
      <app-graph [graph]="graph" [graphConfig]="graphConfig"
                 (dateRangeChanged)="onGraphDateRangeUpdated($event)"
                 (resetGraph)="onReset()"
      ></app-graph>
    </div>

    <div class="col-12 col-md-3" *ngIf="!featureReport">
      <div *ngIf="loadingSecondary" style="margin-top: 50px;"
           class="spinner-border text-primary frame-wrap container-fluid d-flex justify-content-md-center align-items-center"
           role="status">
        <span class="sr-only">Loading...</span>
      </div>

      <app-saving [saving]="saving" *ngIf="!loadingSecondary"
                  (navOut)="onDesiredPfUpdated()"
                  [showUpdateOption]="true"
                  [scadaMeterId]="selectedMeterAccount.scadaMeterId">
      </app-saving>
    </div>

  </div>

  <div *ngIf="!loadingPrimary && (featureDashboard || featureReport || featureBill)">
    <div class="row" [ngClass]="featureBill ? '' : 'rows-print-as-pages'">&nbsp;</div>

    <div *ngIf="loadingSecondary" style="margin-top: 50px;"
         class="spinner-border text-primary frame-wrap container-fluid d-flex justify-content-md-center align-items-center"
         role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div id="bill" class="panel" *ngIf="!loadingSecondary">
      <div class="panel-hdr">
        <h2>Provisional Bill</h2>
        <div class="panel-toolbar">
          <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip"
                  data-offset="0,10" data-original-title="Fullscreen"></button>
        </div>
      </div>

      <app-bill [bill]="provisionalBill"
                [showHeader]="!featureReport"
                [showBill]="true"
                [showTariff]="true"
                (navOut)="onTariffSelected($event)"
                *ngIf="provisionalBill">
      </app-bill>

      <app-bill [bill]="provisionalBillCompare"
                (navOut)="onTariffSelected($event)"
                *ngIf="provisionalBillCompare && !loadingCompare"
                [showHeader]="false" [showBill]="true" [showTariff]="false">
      </app-bill>

      <app-loading *ngIf="loadingCompare" [fullHeight]="loadingCompareFullHeight"></app-loading>

    </div>
  </div>

  <div class="rows-print-as-pages" *ngIf="featureReport && !loadingPrimary">
    <app-saving [saving]="saving" [showUpdateOption]="false"
                [scadaMeterId]="selectedMeterAccount.scadaMeterId">
    </app-saving>
  </div>

  <div *ngIf="featureReport && environmentalImpact && !loadingPrimary">
    <app-line-items [lineItems]="environmentalImpact" [header]="environmentalImpactTitle"></app-line-items>
  </div>

  <div *ngIf="featureReport && summary && !loadingPrimary">
    <app-line-items [lineItems]="summary" [header]="summaryTitle"></app-line-items>
  </div>
</div>

<app-loading *ngIf="loadingPrimary" [fullHeight]="loadingFullHeight"></app-loading>
